export default{
    feedback : {
        experience : '',
        preferredEvaluationModel : '',
        gift : '',
        testimonial: '',
        acceptContact: false
    }
}